import React from 'react';
import siteLogoRight from '../../assets/Famphy-clinic-website.png';
import { Link } from 'react-router-dom';
export default function logo() {
  return (
    <div className="sitelogo-box rigt">
        <Link className="nav-link" to="/famphy-clinics"><img src={siteLogoRight } alt="Famphy Clinic Logo" className="sitelogo" /> </Link>     
    </div>
  );
}
